import { useState } from 'react';
import ChannelsHeader from '../components/ChannelsHeader';
import ChannelsTable from '../components/ChannelsTable';

export default function Channels() {
    const [refreshKey, setRefreshKey] = useState(0);

    const handleChannelAdded = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <div className="space-y-6">
            <ChannelsHeader onChannelAdded={handleChannelAdded} />
            <ChannelsTable key={refreshKey} />
        </div>
    );
}
